import axios from 'axios';
import BaseAPI from './base/base-api';

class NotificationAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'notifications';
}

export default new NotificationAPI();
